import { FAIcon } from "./faIcon.js";
import { FALayerIcon, FALayerIconPart } from "./faLayerIcon.js";
import { Helper } from "../util/helper.js";
import { Sheet } from "../../../siteManagement/sheet.js";
import { General, KeyboardShortcut } from "../../../siteManagement/general.js";
import { EventType } from "../../../siteManagement/eventManager.js";
import { CreateRequired } from "../../commonInterfaces.js";
import React from "react";

export class ToggleButton extends React.Component<ToggleButtonProps, ToggleButtonState>{
    private sheet: Sheet;

    constructor(props) {
        super(props);
        this.state = { value: props.initialValue || false };
        this.sheet = General?.Sheet?.Manager?.getTopMostSheet();
        if (this.sheet) {
            this.initShortCut();
        }
    }

    private initShortCut = () => {
        if (Helper.hasValue(this.props.shortcut)) {
            General.Events.bind(EventType.ShortCut, (shortcut: KeyboardShortcut) => {
                if (General.Sheet.Manager.getTopMostSheet().id() === this.sheet.id() && !Helper.isDialogOpen()) {
                    if (shortcut.ctrl == this.props.shortcut.ctrl && shortcut.alt == this.props.shortcut.alt && shortcut.shift == this.props.shortcut.shift && shortcut.key == this.props.shortcut.key) {
                        this.setValue();
                    }
                }
            });
        }
    }

    private setValue = () => {
        if (!this.props.readOnly) {
            this.setState({ value: !this.state.value }, () => {
                if (this.props.handleToggle)
                    this.props.handleToggle(this.state.value);
            });
        }
    }

    private handleClick = (e: React.MouseEvent<HTMLDivElement>) => {
        if (typeof this.props.handleClick === "function") {
            this.props.handleClick(e);
        }
        this.setValue();
    }

    componentDidUpdate(prevProps: ToggleButtonProps) {
        if ((prevProps.value !== this.props.value) && (typeof this.props.value == "boolean")) {
            this.setState({ value: this.props.value });
        }
    }

    render() {
        let buttonStyle: React.CSSProperties = {
            borderRightWidth: this.props.isInGroup && !this.props.isLastInGroup ? "0px" : "1px"
        };

        buttonStyle = $.extend({}, buttonStyle, this.props.buttonStyle);
        const iconStyle: React.CSSProperties = $.extend({}, { color: this.state.value ? "black" : "#B9B9B9" }, this.props.iconStyle);
        const className = "toggle_button " + (this.props.readOnly ? "toggle_button-disabled " : "toggle_button-enabled ") + (this.state.value ? "toggle_button-active" : "toggle_button-inactive")
        return (
            <div title={this.props.title} style={buttonStyle} onClick={this.handleClick} className={className}>
                {
                    this.props.iconText != null ?
                        <span style={{ color: this.state.value ? "black" : "#B9B9B9" }}>{this.props.iconText}</span> :
                        (Array.isArray(this.props.layerIcons) ? <FALayerIcon wrapperToolTip={this.props.title} icons={this.props.layerIcons} style={iconStyle} /> : <FAIcon prefix={this.props.prefix} wrapperToolTip={this.props.title} name={this.props.iconName} sameWidth={true} style={iconStyle}></FAIcon>)
                }
            </div>
        );
    }
}

interface ToggleButtonState {
    value: boolean;
}

export type ToggleButtonProps = CreateRequired<IToggleButtonProps, "iconText"> | CreateRequired<IToggleButtonProps, "iconName"> | CreateRequired<IToggleButtonProps, "layerIcons">;

interface IToggleButtonProps {
    initialValue?: boolean;
    value?: boolean;
    title?: string;
    iconName?: string;
    iconText?: string;
    iconStyle?: React.CSSProperties;
    readOnly?: boolean;
    buttonStyle?: React.CSSProperties;
    handleToggle(value: boolean);
    isInGroup?: boolean;
    isLastInGroup?: boolean;
    handleClick?(e?: React.MouseEvent<HTMLDivElement>);
    layerIcons?: Array<FALayerIconPart>;
    shortcut?: ButtonShortcut;
    prefix?: "fal" | "far" | "fas";
}

interface ButtonShortcut {
    ctrl: boolean;
    shift: boolean;
    alt: boolean;
    key: string;
}